import { change, date } from 'common/changelog';
import { jazminite, Arbixal } from 'CONTRIBUTORS';

export default [
  change(date(2023, 11, 27), 'Update for trinket object structure change.', jazminite),
  change(date(2023, 2, 23), 'Added better guidance around the use of Swiftmend.', Arbixal),
  change(date(2023, 2, 20), 'Fixed Revitalize for multiple resto druids in raid.', Arbixal),
  change(date(2023, 2, 6), 'Add clearcasting analyzer, relaxed Wild Growth categorization, cleaned up spell definitions', Arbixal),
  change(date(2023, 1, 25), 'Add Revitalise, Rejuvenation, Wild Growth, Lifebloom, and Swiftmend Analyzers', Arbixal),
  change(date(2023, 1, 10), 'Add Classic Restoration Druid stub.', jazminite),
];
